export default {
  "gen_btn_avanti": "Avanti",
  "gen_compagnia_aerea": "Compagnia aerea",
  "gen_numero_volo": "Numero volo",
  "gen_partenza": "Partenza",
  "gen_destinazione": "Destinazione",
  "gen_data_volo": "Data volo",
  "gen_data_volo_label": "Inserisci data volo",
  "aerop_nessun_risultato":"Nessun risultato trovato per ",
  "header_title": "OTTIENI IL TUO RIMBORSO",
  "header_body": "<h1 class=\"headText\"><span class=\"bigSize\">S</span>COPRI SUBITO SE HAI DIRITTO A FINO <span class=\"colorBlue bigSize\">600€</span> DI RIMBORSO!</h1><div class=\"subText\"> • Invia una richiesta per ogni codice di prenotazione • <br>• Se il viaggiatore è un minore, è necessario che la richiesta sia inoltrata da uno dei genitori•</div>",
  "st1_scegliere_compagnia": "Scegliere una compagnia",
  "st1_numero_volo_required": "E' necessario inserire il numero volo",
  "st1_numero_volo_invalid": "Il numero volo non è nel formato corretto",
  "st1_cerca_aeroporto": "Scrivi aeroporto o città",
  "st1_data_volo_required": "Inserire la data del volo nel formato gg/mm/aaaa",
  "st1_data_volo_eccedente": "E' possibile inserire solo voli in data già trascorsa o in programmazione per i prossimi 14 giorni",
  "st1_tipologia_problema": "Seleziona il tipo di problema",
  "st1_tipologia_problema_label": "Problema riscontrato",
  "st1_tipologia_problema_required": "Selezionare una problematica",
  "st1_domanda_coincidenze": "Il tuo volo prevedeva coincidenze?",
  "st1_coincidenze_opt1": "Si",
  "st1_coincidenze_opt2": "No",
  "st1_compagnia_aerea": "Compagnia Aerea",
  "st1_partenza": "⮭ Seleziona partenza",
  "st1_partenza_label": "Aeroporto partenza",
  "st1_destinazione": "⮯ Seleziona destinazione",
  "st1_destinazione_label": "Aeroporto destinazione",
  "st2_problematica_ritardo" : "RITARDO SUPERIORE ALLE 3 ORE",
  "st2_problematica_cancellazione" : "CANCELLAZIONE VOLO",
  "st2_problematica_bagaglio" : "SMARRIMENTO BAGAGLIO",
  "st2_problematica_overbooking" : "OVERBOOKING",
  "err_attenzione": "Attenzione!",
  "err_terminiscaduti": "Termini scaduti",
  "err_terminiscaduti_msg": "Siamo spiacenti, ma non possiamo accettare il caso in quanto sono trascorsi i termini di due anni per richiedere il rimborso.",
  "err_errore_sistema": "Ci dispiace comunicarti che si è verificato un errore inaspettato durante l'operazione. Riprova tra qualche minuto.",
  "err_datalimitata":"Per la compagnia selezionata è possibile inserire solo voli dal 15 ottobre 2021 in poi",
  "last_instestazione" : "Richiesta inserita correttamente!",
  "last_corpo" : "Grazie per averci dato fiducia. Riceverai a breve una comunicazione relativa alla tua richiesta",
  "last_button" : "Inserisci nuova richiesta",
  "numvolo_hint" : "<p>Selezionando la compagnia aerea la parte iniziale viene compilata automaticamente, non resta che inserire la parte numerica composta da quattro cifre.<br><b>Se il tuo numero di volo è composto da 3 soli numeri, inserisci uno zero iniziale: se il tuo volo è FR123 dovrai scrivere FR<span style='color:#bb271b'>0</span>123.</b><br>Numeri di volo validi sono : EJU2865, VY6375, FR4001, FR0123, LH0034...</p>",
  "problematica1" : "RITARDO OLTRE LE 3 ORE",
  "problematica2" : "CANCELLAZIONE",
  "problematica3" : "SMARRIMENTO BAGAGLIO",
  "problematica4" : "OVERBOOKING",
  "st4_nome" : "Inserisci il tuo nome",
  "st4_nome_label" : "Nome",
  "st4_cognome" : "Inserisci il tuo cognome",
  "st4_cognome_label" : "Cognome",
  "st4_email" : "Inserisci un indirizzo email valido",
  "st4_email_label" : "Email",
  "st4_telefono" : "Inserisci un recapito telefonico",
  "st4_telefono_label" : "Telefono",
  "st4_compagnia" : "Compagnia",
  "st4_nvolo" : "N°Volo",
  "st4_partenza" : "Partenza",
  "st4_destinazione" : "Destinazione",
  "st4_tipoproblema" : "Tipologia disservizio",
  "st4_istruzioni" : "Spiegaci in poche parole il problema",
  "st4_datavolo" : "Data volo",
  "st4_istruzioni_placeholder" : "Scrivi qui... (Es.: in data 01/01/2021 ho ricevuto una email dall'agenzia di viaggi, nella quale ci veniva indicata la cancellazione del volo).",
  "st4_modificaidati" : "Modifica i dati",
  "gen_possieuncodicepriorita":"Possiedi un codice priorità ?",
  "gen_possieuncodicepriorita_placeholder":"Codice priorità",
  "st3_telefono_required":"Inserire un recapito telefonico",
  "st1_partenza_required": "Indicare un aeroporto di partenza",
  "st1_destinazione_required": "Indicare un aeroporto di destinazione",
  "st3_nome_required": "Indicare il proprio nome",
  "st3_cognome_required": "Indicare il proprio cognome",
  "st3_email_required": "Indicare il proprio indirizzo email",
  "st3_email_invalid": "Indirizzo email non valido",
  "st3_phone_required": "Inserire un recapito telefonico",
  "st3_codicepartner_required": "Inserire un codice priorità valido oppure omettere questa informazione",
  "gen_conferma": "Conferma",
  "st5_vuoi_completare": "Vuoi dimezzare gratuitamente i tempi di elaborazione della pratica?",
  "st5_vai": "Vai",
  "st6_dimunzionetempi": "Diminuzione dei tempi di elaborazione 25%",
  "st6_codicefiscale": "Inserici codice fiscale",
  "st6_codicefiscale_label": "Cod. fiscale passeggero",
  "st6_nome_required": "Inserire il nome del passeggero",
  "st6_cognome_required": "Inserire il cognome del passeggero",
  "st6_codicefiscale_required": "Inserire il codice fiscale oppure indicare il passeggero come cittadino non italiano",
  "st6_codicefiscale_length": "Codice fiscale non valido",
  "st6_codicefiscale_invalid": "Codice fiscale non valido",
  "st6_codicefiscale_minore": "E' necessario inserire prima un passeggero maggiorenne",
  "st6_firma_required": "E' necessario apporre una firma da inserire nel mandato",
  "st6_cancellafirma": "Cancella firma",
  "st6_bottoneavanti": "Taglia il 40%",
  "gen_data_nonvalida": "Data non valida",
  "st7_bottoneavanti": "Taglia il 50%",
  "st7_inseriscidata": "Inserisci la data",
  "st8_riprotezione": "Riprotezione d parte della compagnia aerea?",
  "gen_si": "Sì",
  "gen_no": "No",
  "st7_diminuzionetempi": "Diminuzione dei tempi di elaborazione ",
  "st8_diminuzionetempi": "Diminuzione dei tempi di elaborazione ",
  "gen_datanonvalida" : "Data non valida",
  "st8_datariprotezione_required" : "Inserire data riprotezione",
  "st8_datariconsegna_required" : "Inserire data riconsegna bagaglio",
  "st8_inviatutto" : "Invia tutto",
  "tk1_heading_1": "PERFETTO, HAI DIMEZZATO I TEMPI DELLA NOSTRA ELABORAZIONE!",
  "tk1_text_1" : "La tua richiesta ha il seguente cod. identificativo :",
  "tk1_text_2" : "Vorresti aggiungere altri passeggeri a questa richiesta di rimborso ?",
  "tk1_button_nuovo_passeggero" : "Nuovo passeggero",
  "tk1_button_concludi" : "Concludi",
  "ticket_esistente_heading1": "Ticket Esistente",
  "ticket_esistente_text": "Esiste già un ticket associato al tuo indirizzo email per il volo che hai indicato.Riceverai a breve un'email con le istruzioni da seguire",
  "pass_seleziona_tutor":"Seleziona un tutor per questo passeggero",
  "st1_numero_volo_nonvalido":"Numero volo non valido",
  "st2_domanda_coincidenze":"Il tuo volo prevedeva coincidenze ?",
  "fup_caricafile":"Carica file",
  "fup_dimensione":"Dimensione file",
  "fup_warningdimensione":"Attenzione! Il file supera le dimensioni massime consentite",
  "fup_conferma":"Conferma",
  "fup_annulla":"Annulla",
  "fup_riprova":"Riprova",
  "fup_uploaderror":"Si è verificato un errore con l'upload del file. Continuare senza caricare il file oppure riprovare in un secondo momento",
  "error_generic_titolo":"Errore inaspettato!!",
  "error_generic_text":"Si è verificato un errore inaspettato con la comunicazione verso il server. Si consiglia di riprovare tra qualche minuto.",
  "st6_nome_label": "Nome passeggero",
  "st6_nome": "Inserire il nome",
  "st6_cognome_label": "Cognome passeggero",
  "st6_cognome": "Inserire il cognome",
  "st6_dichiarazione_non_italiano": "Dichiaro di non essere cittadino italiano e di non possedere un codice fiscale valido.",
  "dimensione_max_10mb" : "Dimensione max 10MB",
  "documento_identita" : "Carta di identità passeggero",
  "carta_imbarco" : "Carta imbarco",
  "PIR" : "PIR ( Property irregularity Report)",
  "giorno_in_cui_ha_ricevuto_comunicazione" : "Giorno in cui hai ricevuto la comunicazione della variazione  (cancellazione o posticipo) del volo",
  "acquisti_successivi": "Acquisti successivi alla variazione del volo",
  "scontrini_ricevute":"Scontrini/Ricevute",
  "file_caricati": "File caricati",
  "nessun_file_caricato" : "Nessun file caricato",
  "bagaglio_riconsegnato": "Bagaglio riconsegnato",
  "se_si_inserisci_data" : "Se sì, Inserisci la data",
  "taglia_il_25" : "Taglia il 25%",
  "taglia_il_40" : "Taglia il 40%",
  "taglia_il_50" : "Taglia il 50%",

}
